import React, { useState, useEffect } from 'react'
import { PropagateLoader } from 'react-spinners'
import DataTables from '../LMS_DATA_TABLE/DataTable'
import { useDispatch, useSelector } from 'react-redux'
import { enrollCourseListRes, enrollCourseListTodo } from '../../LMS_Redux/LMS_Slices/Course/EnrollCourseList'
import { MdOutlineCancel, MdOutlineCheckCircle } from 'react-icons/md'
import { Tooltip } from 'react-tooltip'
import Swal from 'sweetalert2'
import { enrollCourseApprovalRes, enrollCourseApprovalTodo } from '../../LMS_Redux/LMS_Slices/Course/EnrollCourseApproval'

export default function EnrollList() {

    const [loading, setLoading] = useState(false)
    const [bool, setBool] = useState(false)
    const dispatch = useDispatch()
    const data = useSelector(state => state.enrollCourseList && state.enrollCourseList.data && state.enrollCourseList.data.data)

    const mergedArray = data && data.selfReadingCourseList && data.selfReadingCourseList.map((item) => {
        const user = data && data.userList && data.userList.find((obj) => obj.vemp_code === item.user_id);
        return { ...item, user, name_and_code: user ? `${user.vemp_fname} - (${user.vemp_company_code})` : null };
    })
    // console.log(mergedArray)

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'IMAGE',
            field: 'lms_master_course.thumbnail_image',
            cellRenderer: (params) => <img src={process.env.REACT_APP_IMAGE_URL + `${params.value}`} alt="img" className='img-fluid' width="50" height="50" />,
            suppressMenu: true,
            filter: false,
            sortable: false,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'USER NAME',
            field: 'name_and_code',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'TITLE',
            field: 'lms_master_course.course_title',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'ID',
            field: 'lms_master_course.course_code',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'REVISION',
            field: 'lms_master_course.revise',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'STATUS',
            field: 'approval_status',
            cellRenderer: params => params.value == 'approved' ? <span className='badge text-bg-success text-capitalize'>{params.value}</span> : params.value == 'rejected' ? <span className='badge text-bg-danger text-capitalize'>{params.value}</span> : <span className='badge text-bg-warning text-capitalize'>{params.value}</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true
        },
        {
            field: 'ACTIONS',
            cellRenderer: params =>
                <div>
                    {/* <FaEye size={20} className='eye'
                        onClick={() => handleShow(params.data)}
                        data-tooltip-id='details'
                        data-tooltip-content="External Training Details!"
                        data-tooltip-place="bottom"
                    /> */}
                    {params.data.approval_status == 'pending' ?
                        <>
                            <MdOutlineCheckCircle size={20} className='edit ms-3'
                                onClick={() => change_status(params, 'approved')}
                                data-tooltip-id='approve'
                                data-tooltip-content="Approve!"
                                data-tooltip-place="bottom"
                            />
                            <MdOutlineCancel size={20} className='delete ms-3'
                                onClick={() => change_status(params, 'rejected')}
                                data-tooltip-id='reject'
                                data-tooltip-content="Reject!"
                                data-tooltip-place="bottom"
                            />
                        </>
                        : ''
                    }

                    {/* <Tooltip id='details' style={{ backgroundColor: "rgb(34, 98, 198)", zIndex: '9', lineHeight: 'normal' }} /> */}
                    <Tooltip id='approve' style={{ backgroundColor: "rgb(71, 187, 76)", zIndex: '9', lineHeight: 'normal' }} />
                    <Tooltip id='reject' style={{ backgroundColor: "rgb(239, 61, 80)", zIndex: '9', lineHeight: 'normal' }} />
                </div>,
            // wrapText: true,
            autoHeight: true,
        }
    ])

    const change_status = (params, status) => {
        Swal.fire({
            title: `Enroll Learning Module Approval`,
            text: `Are you sure want to ${status} Learning Module?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#105684',
            cancelButtonColor: '#9d9d9d',
            confirmButtonText: 'Ok'
        }).then((result) => {
            if (result.isConfirmed) {
                // setLoading(true)
                dispatch(enrollCourseApprovalTodo({ "data": params.data, "status": status })).then(() => change_status_res())
            }
        })
    }

    const change_status_res = () => {
        if (enrollCourseApprovalRes && enrollCourseApprovalRes.success) {
            Swal.fire(
                'Approval Status',
                enrollCourseApprovalRes.message,
                'success'
            )
            setLoading(true)
            dispatch(enrollCourseListTodo()).then(() => enroll_res())
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: enrollCourseApprovalRes.message,
            })
        }
    }

    const enroll_res = () => {
        if (enrollCourseListRes && enrollCourseListRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(enrollCourseListTodo()).then(() => enroll_res())
    }, [bool])

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Learning Module Management / </span>
                    <span className='icon2'>Enrollment List</span>
                </div>

                {loading ?
                    <div className='wrapper-admin'>
                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>
                    </div>
                    :
                    <DataTables
                        rowData={mergedArray}
                        columnDefs={columnDefs}
                    />
                }
            </div>
        </>
    )
}
